import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import './Navbar.css';
import { Button } from './Button';
import  DropdownAbout from './DropdownAbout';
import DropdownMinistries from './DropdownMinistries';

function Navbar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);

    const [dropdown1, setDropdown1] = useState(false);
    const [dropdown2, setDropdown2] = useState(false);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const toggleDropdown1 = () => {
        setDropdown1(!dropdown1);
    }
    const toggleDropdown2 = () => {
        setDropdown2(!dropdown2);
    }
   
// handle click outside dropdown component

    const closeDropdown1 = (e) => {
        if(!refOne.current.contains(e.target)){
            setDropdown1(false)
        }
    }

    // keep getting errors about "cannot read properties of .contains "null""
    const refOne = useRef(false)
    const refTwo = useRef(false)

    useEffect(() => {
        document.addEventListener('click', closeDropdown1, true)
    }, [])

    const closeDropdown2 = (e) => {
        if(!refTwo.current.contains(e.target)){
            setDropdown2(false)
        }
    }

    useEffect(() => {
        document.addEventListener('click', closeDropdown2, true)
    }, [])
 

    // display button
    const showButton = () => {
        if(window.innerWidth <= 1024) {
            setButton(false)
        } else {
            setButton(true)
        }
    };
// render button one time and don't let it show up anymore (otherwise on refresh, the button will show up)
    useEffect(() => {
        showButton();
      }, []);

    window.addEventListener('resize', showButton)
    


  return (
    <div>
        <nav className="navbar">
            <div className="navbar-container">
                <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
                   <img src={require('../img/cross_logo_lg.png')} className='img nav-logo-cross'></img>
                   <strong>Grace Community Fellowship</strong> 
                </Link>
                <div className='menu-icon' onClick={handleClick}>
                    <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                </div>
                {/* the below 'nav-menu active' makes the mobile menu disappear when a link is clicked */}
                <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                    <li className='nav-item' onClick={toggleDropdown1} ref={refOne}>
                        <Link className='nav-links'>
                            About <i className={dropdown1 ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                        </Link>
                        {dropdown1 && <DropdownAbout props={closeMobileMenu}/>} 
                    </li>
                    <li className='nav-item'  onClick={toggleDropdown2} ref={refTwo}>
                        <Link className='nav-links'>
                            Ministries  <i className={dropdown2 ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                        </Link>
                        {dropdown2 && <DropdownMinistries props={closeMobileMenu}/>}
                    </li>
                    <li className='nav-item'>
                        <Link to='/sermons' className='nav-links' onClick={closeMobileMenu}>
                            Sermons
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link to='/calendar' className='nav-links' onClick={closeMobileMenu}>
                            Calendar
                        </Link>
                    </li>
                    
                    <li className='nav-item'>
                        <Link to='/giving' className='nav-links' onClick={closeMobileMenu}>
                            Giving
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link to='/contact-us' className='nav-links' onClick={closeMobileMenu}>
                            Contact Us
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link to='https://gcftx.ccbchurch.com/index.php' className='grace-connect-btn' target='blank' onClick={closeMobileMenu}>
                        <i className='fa fa-user'></i>  Grace Connect
                        </Link>
                    </li>
                    {/* <li>
              <Link
                to='https://gcftx.ccbchurch.com/index.php'
                className='nav-links-mobile'
                onClick={closeMobileMenu}
                target='blank'
              >
                <i className='fa fa-user'></i> Grace Connect
              </Link>
            </li> */}
                </ul>
                {/* {button && <Button buttonStyle='btn--primary' buttonSize='btn--medium'><i className='fa fa-user fa-fw'></i> Grace Connect</Button>} */}
            </div>
        </nav>
    </div>
  )
};

export default Navbar
